import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';

import {
    ActionsColumn,
    ApnCountColumn,
    CarrierColumn,
    IdColumn,
    UpstreamCarrierColumn,
} from './components';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import ApnDefinitionsTable from './apnDefinitionTable/ApnDefinitionsTable';
import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import { MantineReactTable } from 'mantine-react-table';
import classes from '../../../../css/DetailPanelTable.module.css';
import { getApns } from '../../../../http/apiClient';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const ApnsView = ({ ...props }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) => getApns(queryParams),
        queryKey: ['apns'],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
    });

    const { data: apns, pagination: dataPagination } = paginatedData || {};
    const columns = useMemo(
        () => [IdColumn(), CarrierColumn(), ApnCountColumn()],
        [apns]
    );

    const tableData = useMemo(() => (isLoading ? [] : apns), [apns, isLoading]);

    const [columnVisibility, setColumnVisibility] = useLocalStorage({
        key: 'apns-table-visibility', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const [columnSizing, setColumnSizing] = useLocalStorage({
        key: 'apns-group-table-sizing', // a unique key for local storage
        defaultValue: {}, // default to all columns shown if empty
        getInitialValueInEffect: true,
    });

    const handleVisibilityChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnVisibility((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handlSizeChange = (changeFunc) => {
        const changes = changeFunc();
        setColumnSizing((prevState) => ({
            ...prevState,
            ...changes,
        }));
    };

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: false,
        enableColumnResizing: true,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        positionExpandColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search APNs',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: '80vh',
            },
        },
        positionGlobalFilter: 'left',
        renderTopToolbarCustomActions: () => (
            <Box
                w={'100%'}
                px={'lg'}>
                <FiltersMultiSelect
                    options={[{ label: 'test', value: 'test' }]}
                />
            </Box>
        ),
        renderDetailPanel: ({ row, table }) => {
            return (
                <>
                    <ApnDefinitionsTable apns={row.original.apns} />
                </>
            );
        },

        mantineTableBodyRowProps: ({
            isDetailPanel,
            row,
            staticRowIndex,
            table,
        }) => ({
            className: isDetailPanel ? classes.rowPadding : null,
            onClick: (e) => {
                const INTERACTIVE_SELECTOR =
                    'a[href], button, input:not([type="hidden"]), select, textarea, label, [role="button"]';
                const interactiveElemnt =
                    e.target instanceof HTMLElement &&
                    e.target.closest(INTERACTIVE_SELECTOR);
                if (interactiveElemnt) return;

                if (!isDetailPanel) {
                    row.toggleExpanded();
                }
            },
        }),
        //renderRowActions: ActionsColumn,

        enableExpanding: true,
        manualPagination: true,
        manualSorting: true,
        onColumnVisibilityChange: handleVisibilityChange,
        onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            columnVisibility,
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            columnVisibility,
            columnSizing,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return (
        <Container fluid>
            <MantineReactTable {...tableProps} />
        </Container>
    );
};
export default ApnsView;
